export default [
    {
        path: "/VGM",
        component: () => import("@/views/VGM/Draft"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/all",
        component: () => import("../../views/VGM/AllVGM"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/new",
        name: "CreateVGM",
        component: () => import("@/views/VGM/components/AddVGMDialog.vue"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/wait",
        component: () => import("@/views/VGM/WaitSend"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/already",
        component: () => import("@/views/VGM/AlreadySend"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/uandd",
        component: () => import("@/views/VGM/UpdateDelete"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/guide/agreement",
        component: () => import("@/views/VGM/guide/Agreement.vue"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
    {
        path: "/VGM/guide/book",
        component: () => import("@/views/VGM/guide/Book.vue"),
        meta: { activeMenu: "/VGM", needCompanyRole: true },
    },
];
